import { render } from "./ExpertSelection.vue?vue&type=template&id=1c5e6058"
import script from "./ExpertSelection.vue?vue&type=script&lang=js"
export * from "./ExpertSelection.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__